import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import EductorSave from "./EductorSave";
import EductorAddTest from "./EductorAddTest";
import EductorPrint from "./EductorPrint";
//import { Line } from 'react-chartjs-2';
import { Chart, registerables } from "chart.js"
import { LineChart, Line, XAxis, YAxis, ZAxis, CartesianGrid, Tooltip, Legend, Label, Scatter, ScatterChart, ResponsiveContainer, ReferenceLine } from 'recharts';
import EductorGetCustomer from "./EductorGetCustomer";
import { parse } from "popper/farms/saucelabs";
import EductorDelete from "./EductorDelete";


Chart.register(...registerables);


const EductorDetails = () => {

    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();

    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });

    const { id } = useParams();

    //get eductor data
    let response76 = useInvoke("Eductor", "76", { "eductorID": id });

    //get users
    let response64 = useInvoke("WebApps", "64", {});

    //get tests
    let response75 = useInvoke("Eductor", "75", { "eductorID": id });

    const [eductor, setEductor] = useState({});
    const [users, setUsers] = useState([]);
    const [tests, setTests] = useState([]);

    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {

        if (response76.data.payload != undefined) {

            if (!response76.data.success) {
                toast.error("There was an error retrieving the eductor");
                return;
            }

            let data = JSON.parse(response76.data.payload).data[0];

            let datecompleted = "";
            let bspr_datecompleted = "";

            const parts5 = data[5].split('/');
            const parts23 = data[23].split('/');

            if (parts5.length > 1) {
                datecompleted = new Date(parts5[2], parts5[0] - 1, parts5[1]).toISOString().split('T')[0];
            }

            if (parts23.length > 1) {
                bspr_datecompleted = new Date(parts23[2], parts23[0] - 1, parts23[1]).toISOString().split('T')[0];
            }

            let obj = {
                "id": data[0],
                "jobnumber": data[1],
                "quotenumber": data[2],
                "model": data[3],
                "datecreated": data[4],
                "datecompleted": datecompleted,
                "testedbyid": data[6],
                "approvedbyid": data[7],
                "sketchnumber": data[8],
                "frequency": data[9],
                "inletdiameter": data[10],
                "outletdiameter": data[11],
                "horsepower": parseFloat(data[12]).toFixed(0),
                "velocity": parseFloat(data[13]).toFixed(0),
                "cspr_inducedairflow": parseFloat(data[14]).toFixed(0),
                "cspr_inletstaticpressure": data[15],
                "cspr_dischargestaticpressure": data[16],
                "bspr_manufacturermodel": data[17],
                "bspr_airflowcfm": parseFloat(data[18]).toFixed(0),
                "bspr_calculatedbhp": parseFloat(data[19]).toFixed(0),
                "bspr_inletstaticpressure": data[20],
                "bspr_outletstaticpressure": data[21],
                "bspr_purchaseordernumber": data[22],
                "bspr_datecompleted": bspr_datecompleted,
                "apr_plenumpressure": data[24],
                "apr_nozzlesetting": data[25],
                "apr_staticclosedoff": data[26],
                "apr_tight": data[27],
                "apr_motorrpm": parseFloat(data[28]).toFixed(0),
                "apr_motorvoltage": parseFloat(data[29]).toFixed(2),
                "apr_calculatedblowerairflow": data[30],
                "apr_plenumtype": data[31],
                "apr_motoramps1": parseFloat(data[32]).toFixed(2),
                "apr_motoramps2": parseFloat(data[33]).toFixed(2),
                "apr_motoramps3": parseFloat(data[34]).toFixed(2),
                "apr_motorampsaverage": parseFloat(data[35]).toFixed(2),
                "apr_motorampsrated": parseFloat(data[36]).toFixed(2),
                "notes": data[37],
                "customer": data[38],
                "air_temperature": parseFloat(data[39]).toFixed(2),
                "air_humidity": parseFloat(data[40]).toFixed(2),
                "air_pressure": parseFloat(data[41]).toFixed(2),
                "intakesilencer": data[42] == "False" ? 0 : 1,
                "apr_motornotes": data[43],
                "suffix": data[44],
                "air_density": 0
            };

            setEductor(obj);

        }

        //get user list
        if (response64.data.payload != undefined) {
            let data = JSON.parse(response64.data.payload).data;

            let breakpoint = "";

            let userList = [];

            data.forEach((user, index) => {

                let obj = {
                    "id": user[0],
                    "firstname": user[1],
                    "lastname": user[2],
                    "email": user[3],
                    "mustchangepassword": user[4],
                    "role": user[5]
                };

                userList.push(obj);

            });

            setUsers(userList);

        }

    }, [response76.data.payload, response64.data.payload, response75.data.payload]);

    useEffect(() => {
        let breakpoint = "";

        if (document.getElementById("apr_motoramps1") && document.getElementById("apr_motoramps2") && document.getElementById("apr_motoramps3")) {
            handleAmpChange();
        }

        if (document.getElementById("air_temperature") && document.getElementById("air_humidity") && document.getElementById("air_pressure")) {
            handleAirChange(false);
        }

        // if (response75.data.payload !== undefined && eductor["air_density"]) {
        if (response75.data.payload !== undefined) {
            const data = JSON.parse(response75.data.payload).data;
            const testList = [];

            const calcInnerDiameter = (diameter, thickness) => {
                if (!diameter || !thickness) return 0;
                const thicknessMap = {
                    "1/32": 1 / 32,
                    "1/16": 1 / 16,
                    "1/8": 1 / 8,
                    "3/16": 3 / 16,
                    "1/4": 1 / 4,
                    "1/2": 1 / 2
                };
                const t = thicknessMap[thickness];
                return t ? parseFloat(diameter) - (2 * t) : 0;
            };

            const calcArea = (innerDiameter) => {
                return parseFloat((innerDiameter * 0.5) ** 2 * Math.PI / 144);
            };


            data.forEach((test, index) => {
                let vpSum = 0;
                let vpCount = 0;

                const rawVPs = [];
                for (let i = 8; i <= 18; i++) {
                    const raw = parseFloat(test[i]);
                    rawVPs.push(isNaN(raw) ? 0 : raw);

                    if (!isNaN(raw) && raw > 0) {
                        vpSum += Math.sqrt(raw);
                        vpCount++;
                    }
                }

                const avgVp = vpCount > 0 ? vpSum / vpCount : 0;
                const airDensity = parseFloat(eductor["air_density"]);
                const airDensityFactor = Math.sqrt(airDensity);
                const velocity = avgVp > 0 && airDensityFactor > 0 ? (avgVp / airDensityFactor) * 1096 : 0;

                const diameter = parseFloat(test[5]);
                const gauge = test[22];
                const innerDiameter = calcInnerDiameter(diameter, gauge);
                const area = calcArea(innerDiameter);

                const cfm = velocity * area;

                const obj = {
                    "id": test[0],
                    "percentage": test[2],
                    "inletoutlet": test[3],
                    "blowerintake": test[4],
                    "diameter": diameter,
                    "area": isNaN(area) ? "0.000" : area,
                    "staticpressure": parseFloat(test[7]),
                    "vp1": rawVPs[0],
                    "vp2": rawVPs[1],
                    "vp3": rawVPs[2],
                    "vp4": rawVPs[3],
                    "vp5": rawVPs[4],
                    "vp6": rawVPs[5],
                    "vp7": rawVPs[6],
                    "vp8": rawVPs[7],
                    "vp9": rawVPs[8],
                    "vp10": rawVPs[9],
                    "vp11": rawVPs[10],
                    "average": avgVp,
                    "notes": test[19],
                    "datecreated": test[20],
                    "datemodified": test[21],
                    "velocity": velocity,
                    "cfm": isNaN(cfm) ? "0" : Math.round(cfm).toString(),
                    "gauge": gauge,
                    "innerDiameter": innerDiameter,
                    "area": area
                };

                testList.push(obj);
            });

            setTests(testList);
        }

    }, [eductor]);

    useEffect(() => {

        //re-render page

    }, [users]);

    useEffect(() => {

        //re-render page

    }, [tests]);

    useEffect(() => {

        //re-render page

    }, [hasUnsavedChanges]);

    const handleSaveChanges = (e) => {

        //e.preventDefault();

        let edcutorid = id;
        let jobnumber = document.getElementById("jobnumber").value;
        let quotenumber = document.getElementById("quotenumber").value;
        let model = document.getElementById("eductormodel").value;
        let datecompleted = document.getElementById("datecompleted").value;
        let testedbyid = document.getElementById("testedby").value;
        let approvedbyid = document.getElementById("approvedby").value;
        let sketchnumber = document.getElementById("sketchnumber").value;
        let frequency = document.getElementById("hz50").checked ? "50" : "60";
        let inletdiameter = document.getElementById("inletdiameter").value;
        let outletdiameter = document.getElementById("outletdiameter").value;
        let horsepower = document.getElementById("horsepower").value;
        let velocity = document.getElementById("velocity").value;
        let csprinducedairflow = document.getElementById("cspr_inducedairflow").value;
        let csprinletstaticpressure = document.getElementById("cspr_inletstaticpressure").value;
        let csprdischargestaticpressure = document.getElementById("cspr_dischargestaticpressure").value;
        let bsprmanufacturermodel = document.getElementById("bspr_manufacturermodel").value;
        let bsprairflowcfm = document.getElementById("bspr_airflowacfm").value;
        let bsprcalculatedbhp = document.getElementById("bspr_calculatedbhp").value;
        let bsprinletstaticpressure = document.getElementById("bspr_inletstaticpressure").value;
        let bsproutletstaticpressure = document.getElementById("bspr_outletstaticpressure").value;
        let bsprpurchaseordernumber = document.getElementById("bspr_internalpo").value;
        let bsprdatecompleted = document.getElementById("bspr_datecompleted").value;
        let aprplenumpressure = document.getElementById("apr_plenumpressure").value;
        let aprnozzlesetting = document.getElementById("apr_nozzlesetting").value;
        let aprstaticclosedoff = document.getElementById("apr_staticclosedoff").value;
        let aprtight = document.getElementById("apr_tightorloose").value;
        let aprmotorrpm = document.getElementById("apr_motorrpm").value;
        let aprmotorvoltage = document.getElementById("apr_motorvoltage").value;
        let aprcalculatedblowerairflow = document.getElementById("apr_calculatedblowerairflow").value;
        let aprplenumtype = document.getElementById("apr_plenumtype").value;
        let aprmotoramps1 = document.getElementById("apr_motoramps1").value;
        let aprmotoramps2 = document.getElementById("apr_motoramps2").value;
        let aprmotoramps3 = document.getElementById("apr_motoramps3").value;
        let aprmotorampsaverage = document.getElementById("apr_averageamps").value;
        let aprmotorampsrated = document.getElementById("ratedamps").value;
        let notes = document.getElementById("notes").value;
        let air_temperature = document.getElementById("air_temperature").value;
        let air_humidity = document.getElementById("air_humidity").value;
        let air_pressure = document.getElementById("air_pressure").value;
        let intakesilencer = document.getElementById("intakesilencer").value;
        let aprmotornotes = document.getElementById("apr_motornotes").value;
        let suffix = document.getElementById("suffix").value;

        EductorSave(
            edcutorid, jobnumber, quotenumber, model,
            datecompleted, testedbyid, approvedbyid, sketchnumber,
            frequency, inletdiameter, outletdiameter, horsepower,
            velocity, csprinducedairflow, csprinletstaticpressure, csprdischargestaticpressure,
            bsprmanufacturermodel, bsprairflowcfm, bsprcalculatedbhp, bsprinletstaticpressure,
            bsproutletstaticpressure, bsprpurchaseordernumber, bsprdatecompleted,
            aprplenumpressure, aprnozzlesetting, aprstaticclosedoff, aprtight,
            aprmotorrpm, aprmotorvoltage, aprcalculatedblowerairflow, aprplenumtype,
            aprmotoramps1, aprmotoramps2, aprmotoramps3, aprmotorampsaverage,
            aprmotorampsrated, notes, air_temperature, air_humidity, air_pressure, intakesilencer, aprmotornotes, suffix).then((response) => {

                if (response.success) {
                    toast.success("Eductor saved successfully");
                } else {
                    toast.error("There was an error saving the eductor");
                }
            });

    };

    const handleAirChange = (change) => {

        let tempFahrenheit = document.getElementById("air_temperature").value;
        let humidityPercentage = document.getElementById("air_humidity").value;
        let pressureInchesMercury = document.getElementById("air_pressure").value;

        let tempCelsius = ((parseFloat(tempFahrenheit) - 32) / 1.8);
        let tempKelvin = (parseFloat(tempFahrenheit) + (459.67)) * (5 / 9);

        let pressurePascals = parseFloat(pressureInchesMercury) * 3386.39;

        let vaporPressure = (parseFloat(humidityPercentage) / 100) * (6.105 ^ (17.27 * parseFloat(tempCelsius) / (parseFloat(tempCelsius) + 237.7)))

        let dryPressure = parseFloat(pressurePascals) - parseFloat(vaporPressure);

        let airDensityKilogramsMeterCubed = (parseFloat(dryPressure) / (287.058 * parseFloat(tempKelvin)));

        let airDensityLbFootCubed = 0.062428 * parseFloat(airDensityKilogramsMeterCubed);

        let obj = eductor;

        obj["air_density"] = airDensityLbFootCubed;

        setEductor(obj);

        document.getElementById("air_density").value = parseFloat(airDensityLbFootCubed).toFixed(10);

        if (change) {
            setHasUnsavedChanges(true);
        }

    };

    const handleAmpChange = (e) => {

        let amps1 = parseFloat(document.getElementById("apr_motoramps1").value);
        let amps2 = parseFloat(document.getElementById("apr_motoramps2").value);
        let amps3 = parseFloat(document.getElementById("apr_motoramps3").value);
        let rated = parseFloat(document.getElementById("ratedamps").value);
        let ampsavg = (parseFloat(amps1) + parseFloat(amps2) + parseFloat(amps3)) / 3;

        // For amps1
        if (amps1 < rated && amps1 > rated * 0.95) {
            document.getElementById("apr_motoramps1").style.backgroundColor = "rgba(255, 165, 0, 0.2)";
        } else if (amps1 >= rated) {
            document.getElementById("apr_motoramps1").style.backgroundColor = "rgba(255, 0, 0, 0.2)";
        } else {
            document.getElementById("apr_motoramps1").style.backgroundColor = "unset";
        }

        // For amps2
        if (amps2 < rated && amps2 > rated * 0.95) {
            document.getElementById("apr_motoramps2").style.backgroundColor = "rgba(255, 165, 0, 0.2)";
        } else if (amps2 >= rated) {
            document.getElementById("apr_motoramps2").style.backgroundColor = "rgba(255, 0, 0, 0.2)";
        } else {
            document.getElementById("apr_motoramps2").style.backgroundColor = "unset";
        }

        // For amps3
        if (amps3 < rated && amps3 > rated * 0.95) {
            document.getElementById("apr_motoramps3").style.backgroundColor = "rgba(255, 165, 0, 0.2)";
        } else if (amps3 >= rated) {
            document.getElementById("apr_motoramps3").style.backgroundColor = "rgba(255, 0, 0, 0.2)";
        } else {
            document.getElementById("apr_motoramps3").style.backgroundColor = "unset";
        }

        // For apr_averageamps
        if (ampsavg < rated && ampsavg > rated * 0.95) {
            document.getElementById("apr_averageamps").style.backgroundColor = "rgba(255, 165, 0, 0.2)";
        } else if (ampsavg >= rated) {
            document.getElementById("apr_averageamps").style.backgroundColor = "rgba(255, 0, 0, 0.2)";
        } else {
            document.getElementById("apr_averageamps").style.backgroundColor = "rgba(238, 238, 238)";
        }

        document.getElementById("apr_averageamps").value = ampsavg.toFixed(2);

    };

    const handleRatedChange = (e) => {

        document.getElementById("apr_ratedamps").value = document.getElementById("ratedamps").value;

        handleAmpChange();

    };

    const handleQuoteNumberChange = (e) => {

        EductorGetCustomer(e.target.value).then((response) => {
            if (response.success && JSON.parse(response.payload).data.length > 0) {
                document.getElementById("customer").value = JSON.parse(response.payload).data[0][0];
                document.getElementById("apr_motoramps1").style.backgroundColor = "rgba(255, 0, 0, 0.2)";
            }
            else {
                document.getElementById("customer").value = "";
                document.getElementById("apr_motoramps1").style.backgroundColor = "rgba(255, 0, 0, 0.2)";
            }
        });

    };

    const handleFrequencyChange = (e) => {

    };

    const handleCreateTemplate = (e) => {

        handleSaveChanges();

        // Welcome to async hell
        let percentageRecipe = [100, 100, 75, 75, 50, 50, 25, 25, 0, 0];
        let inletoutletRecipe = [0, 1, 0, 1, 0, 1, 0, 1, 0, 1];

        for (let i = 0; i < percentageRecipe.length; i++) {
            EductorAddTest("", id, percentageRecipe[i], inletoutletRecipe[i], 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "", "")
                .then((response) => {
                    if (i == percentageRecipe.length - 1) {
                        toast.success("Template created successfully");
                        //navigate("/Eductor");
                        navigate(`/Eductor/Tests/${id}`);
                    }
                });
        }

        // EductorAddTest ("", id, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "").then((response) => {
        //     EductorAddTest ("", id, 100, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "").then((response) => {
        //         EductorAddTest ("", id, 75, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "").then((response) => {
        //             EductorAddTest ("", id, 75, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "").then((response) => {
        //                 EductorAddTest ("", id, 50, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "").then((response) => {
        //                     EductorAddTest ("", id, 50, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "").then((response) => {
        //                         EductorAddTest ("", id, 25, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "").then((response) => {
        //                             EductorAddTest ("", id, 25, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "").then((response) => {
        //                                 EductorAddTest ("", id, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "").then((response) => {
        //                                      EductorAddTest ("", id, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "").then((response) => {
        //                                     if (response.success) {
        //                                         toast.success("Successfully created tests.");
        //                                         navigate("/Eductor");
        //                                     }

        //                                 });            
        //                             });            
        //                         });            
        //                     });
        //                 });            
        //             });
        //         });
        //     });
        // });
    };

    const handleDeleteEductor = () => {

        let eid = id;

        EductorDelete(eid, user["id"])
            .then((response) => {
                if (response.success) {
                    toast.success("Eductor and Eductor Tests archived successfully");
                    navigate("/Eductor");
                }
                else {
                    toast.error("Failed to archive Eductor");
                }
            });

    };

    const PerformanceGraph = (input) => {
        let breakpoint = "";
        let points = [];
        let graphPoints = [];
        let sortedPoints = [];
        let p = [];
        let r = [];
        let data01 = [];
        let data02 = [];

        if (input !== undefined && input["input"].length !== 0 && eductor["cspr_inducedairflow"] !== undefined) {
            input["input"].forEach((item, index) => {
                if (item["inletoutlet"] === "False" && item["percentage"] != 0) {

                    // points.push({ "x": item["cfm"], "y": Math.abs(parseFloat(item["staticpressure"])) });
                    points.push({ "x": parseFloat(item["cfm"]), "y": Math.abs(parseFloat(item["staticpressure"])) });

                }
            });

            sortedPoints = points.sort((a, b) => a.x - b.x);

            //if x is undefined
            if (sortedPoints[0]["x"] === undefined) {
                sortedPoints[0]["x"] = 0;
            }

            data01 = [
                { x: 0, y: Math.abs(parseFloat(eductor["apr_staticclosedoff"])) || 0 },
                ...sortedPoints
            ];



            data02 = [
                { x: parseFloat(eductor["cspr_inducedairflow"]), y: Math.abs(parseFloat(eductor["cspr_inletstaticpressure"])) + Math.abs(parseFloat(eductor["cspr_dischargestaticpressure"])) }
            ];
        };

        return (
            <div style={{ marginLeft: "15%" }}>
                <ResponsiveContainer width="75%" height={600}>
                    <ScatterChart
                        margin={{
                            top: 20,
                            right: 20,
                            bottom: 20,
                            left: 20,
                        }}
                    >
                        <CartesianGrid />
                        {/* <XAxis type="number" dataKey="x" name="cfm" label={{ value: "CFM", position: "insideBottomRight", dy: 25, dx: 10 }} />
                        <YAxis type="number" dataKey="y" name="sp" label={{ value: "Static Pressure", position: "insideBottomRight", dy: -500, dx: -32, angle: -90 }} /> */}

                        <XAxis type="number" dataKey="x" name="cfm" label={{ value: "CFM", position: "insideBottomRight", dy: 25, dx: 10 }} />
                        <YAxis type="number" dataKey="y" name="sp" label={{ value: "Static Pressure", position: "insideBottomRight", dy: -500, dx: -32, angle: -90 }} />

                        <ZAxis type="number" range={[100]} />
                        <Tooltip cursor={{ strokeDasharray: '3 3' }} />
                        <Legend />
                        <ReferenceLine x={parseFloat(eductor["cspr_inducedairflow"])} stroke="#198754" />
                        <ReferenceLine y={Math.abs(parseFloat(eductor["cspr_inletstaticpressure"])) + Math.abs(parseFloat(eductor["cspr_dischargestaticpressure"]))} stroke="#198754" />
                        <Scatter name="Tests" data={data01} fill="#0d6efd" line shape="square" />
                        <Scatter name="Performance Req" data={data02} fill="#198754" line shape="cross" />



                    </ScatterChart>
                </ResponsiveContainer>
            </div>
        );
    };

    document.title = `Eductor Details`;
    return (
        <div className="eductors">
            {user["email"] != undefined &&
                <>
                    {eductor["id"] != undefined &&
                        <>
                            <div className="container" style={{ margin: "auto" }}>

                                <div style={{ display: "flex", flexDirection: "row", margin: "8px 0px", justifyContent: "space-between" }}>

                                    <Link to="/Eductor" className="btn btn-default" style={{}}>Return to Eductor List</Link>
                                    <Link to={`/Eductor/Details/Print/${id}`} className="btn btn-default" style={{}}>Print</Link>

                                </div>

                                <div className="card border-secondary mb-3" style={{ fontSize: "18px", fontWeight: "bold" }}>

                                    {/* <div style={{color: "var(--bs-blue)", fontSize: "22px"}} className="card-header">Eductor Details</div> */}

                                    <div className="card-body">

                                        <div style={{ position: "fixed", right: "8px", bottom: "8px", zIndex: "999" }}>
                                            <button onClick={handleSaveChanges} className="btn btn-success" style={{ marginRight: "4px", width: "168px" }}>Save Changes</button>
                                        </div>

                                        <h4 className="card-title" style={{ fontWeight: "bold", color: "var(--bs-blue)", marginTop: "16px" }}>Model Information</h4>


                                        <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "96%", minWidth: "128px" }}>
                                            
                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: "8px" }}>
                                                <span style={{ color: "var(--bs-secondary)" }}>Eductor Model Name </span>
                                                <i style={{ opacity: "0.5" }}>(ED - &#123;INLET&#125; X &#123;OUTLET&#125; - &#123;HORSEPOWER&#125;HP) Example: <span style={{textDecoration: "underline"}}>ED - 6 X 8 - 5HP</span></i>
                                            </div>

                                            <input defaultValue={eductor["model"]} className="form-control" id="eductormodel" name="eductormodel" type="text" readOnly={false} autoComplete="off" style={{ minWidth: "100%" }} />
                                        </div>

                                        <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "96%", minWidth: "128px" }}>
                                            <label style={{ color: "var(--bs-secondary)" }} htmlFor="suffix">Model (Ext.)</label>
                                            <input defaultValue={eductor["suffix"]} className="form-control" id="suffix" name="suffix" type="text" readOnly={false} autoComplete="off" style={{ minWidth: "100%" }} />
                                        </div>

                                        <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "96%", minWidth: "128px" }}>
                                            <label style={{ color: "var(--bs-secondary)" }} htmlFor="bspr_manufacturermodel">Fan Model Name</label>
                                            <input defaultValue={eductor["bspr_manufacturermodel"]} className="form-control" id="bspr_manufacturermodel" name="bspr_manufacturermodel" type="text" readOnly={false} autoComplete="off" style={{ minWidth: "100%" }} />
                                        </div>

                                        <h4 className="card-title" style={{ fontWeight: "bold", color: "var(--bs-blue)", marginTop: "16px" }}>Job Data</h4>

                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="jobnumber">Job Number</label>
                                                <input defaultValue={eductor["jobnumber"]} className="form-control" id="jobnumber" name="jobnumber" type="text" readOnly={false} autoComplete="off" />
                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="quotenumber">Quote Number</label>
                                                <input onChange={(e) => { handleQuoteNumberChange(e) }} defaultValue={eductor["quotenumber"]} className="form-control" id="quotenumber" name="quotenumber" type="text" readOnly={false} autoComplete="off" />
                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="sketchnumber">Sketch Number</label>
                                                <input defaultValue={eductor["sketchnumber"]} className="form-control" id="sketchnumber" name="sketchnumber" type="text" readOnly={false} autoComplete="off" />
                                            </div>

                                        </div>

                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="customer">Customer</label>
                                                <input onClick={() => { toast("Derived from Quote Number", { icon: "💡" }) }} defaultValue={eductor["customer"]} className="form-control" id="customer" name="customer" type="text" readOnly={true} autoComplete="off" />
                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="bspr_internalpo">Internal PO / Routing</label>
                                                <input defaultValue={eductor["bspr_purchaseordernumber"]} className="form-control" id="bspr_internalpo" name="bspr_internalpo" type="text" readOnly={false} autoComplete="off" />
                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="datecreated">Date Entered</label>
                                                <input onClick={() => { toast("This field is static", { icon: "💡" }) }} defaultValue={eductor["datecreated"]} className="form-control" id="datecreated" name="datecreated" type="text" readOnly={true} autoComplete="off" />
                                            </div>

                                        </div>

                                        <h4 className="card-title" style={{ fontWeight: "bold", color: "var(--bs-blue)", marginTop: "16px" }}>Technical Specifications</h4>

                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="inletdiameter">Inlet Diameter (in)</label>
                                                <input defaultValue={eductor["inletdiameter"]} className="form-control" id="inletdiameter" name="inletdiameter" type="number" readOnly={false} autoComplete="off" />
                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="outletdiameter">Outlet Diameter (in)</label>
                                                <input defaultValue={eductor["outletdiameter"]} className="form-control" id="outletdiameter" name="outletdiameter" type="number" readOnly={false} autoComplete="off" />
                                            </div>



                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="velocity">Velocity</label>
                                                <input defaultValue={eductor["velocity"]} className="form-control" id="velocity" name="velocity" type="number" readOnly={false} autoComplete="off" />
                                            </div>

                                        </div>

                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="ratedamps">Rated Amps</label>
                                                <input onChange={() => { handleRatedChange() }} defaultValue={eductor["apr_motorampsrated"]} className="form-control" id="ratedamps" name="ratedamps" type="number" readOnly={false} autoComplete="off" />
                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="horsepower">Horsepower</label>
                                                <input defaultValue={eductor["horsepower"]} className="form-control" id="horsepower" name="horsepower" type="number" readOnly={false} autoComplete="off" />
                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="frequency">Frequency</label>
                                                <div className="form-group" id="frequency" name="frequency" style={{ display: "flex", flexDirection: "row", margin: "8px", width: "50%", minWidth: "128px" }}>

                                                    <div className="form-check">
                                                        <input className="form-check-input" type="radio" name="hz" id="hz50" value="50" defaultChecked={eductor["frequency"] == "50"} />
                                                        <label className="form-check-label" htmlFor="hz">50 hz</label>
                                                    </div>

                                                    <div className="form-check" style={{ marginLeft: "16px" }}>
                                                        <input className="form-check-input" type="radio" name="hz" id="hz60" value="60" defaultChecked={eductor["frequency"] == "60"} />
                                                        <label className="form-check-label" htmlFor="hz">60 hz</label>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>

                                        <h4 className="card-title" style={{ fontWeight: "bold", color: "var(--bs-blue)", marginTop: "16px" }}>Air Properties During Test</h4>
                                        <Link to="https://www.wunderground.com/history" target="_blank" rel="noopener noreferrer" style={{ fontSize: "14px", textDecoration: "underline", color: "var(--bs-info)", marginLeft: "8px" }}>Historical Weather Data</Link>

                                        {eductor && (
                                            <div style={{ display: "flex", flexDirection: "row" }}>

                                                <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                    <label style={{ color: "var(--bs-secondary)" }} htmlFor="air_temperature">Temperature (°F)</label>

                                                    <input onChange={() => { handleAirChange(true) }} defaultValue={eductor["air_temperature"]} className="form-control" id="air_temperature" name="air_temperature" type="number" readOnly={false} autoComplete="off" />

                                                </div>

                                                <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                    <label style={{ color: "var(--bs-secondary)" }} htmlFor="air_humidity">Humidity (%)</label>

                                                    <input onChange={() => { handleAirChange(true) }} defaultValue={eductor["air_humidity"]} className="form-control" id="air_humidity" name="air_humidity" type="number" readOnly={false} autoComplete="off" />

                                                </div>

                                                <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                    <label style={{ color: "var(--bs-secondary)" }} htmlFor="air_pressure">Air Pressure (inHg)</label>

                                                    <input onChange={() => { handleAirChange(true) }} defaultValue={eductor["air_pressure"]} className="form-control" id="air_pressure" name="air_pressure" type="number" readOnly={false} autoComplete="off" />

                                                </div>

                                                <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                    <label style={{ color: "var(--bs-secondary)" }} htmlFor="air_density">Air Density (lb/ft³)</label>

                                                    <input defaultValue={eductor["air_density"]} onClick={() => { toast("This field is calculated", { icon: "💡" }) }} className="form-control" id="air_density" name="air_density" type="number" readOnly={true} autoComplete="off" />

                                                </div>

                                            </div>

                                        )

                                        }



                                        <h4 className="card-title" style={{ fontWeight: "bold", color: "var(--bs-blue)", marginTop: "16px" }}>Test Information</h4>

                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="testedby">Tested By</label>

                                                {users.length > 0 &&
                                                    <>
                                                        <select id="testedby" defaultValue={eductor["testedbyid"]} className="form-control"
                                                            style={{ fontSize: "14px", color: "#555555", padding: "7px 12px", border: "1px solid #e7e7e7", borderRadius: "4px", boxShadow: "inset 0px 2px 0px rgba(0, 0, 0, 0.075)" }}>
                                                            <option value="">Select User</option>
                                                            {
                                                                users.map((u, index) => (
                                                                    <option key={index} value={u["id"]}>{`${u["firstname"]} ${u["lastname"]} - ${u["email"]}`}</option>
                                                                ))
                                                            }

                                                        </select>

                                                    </>
                                                }

                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="approvedby">Approved By</label>

                                                {users.length > 0 &&
                                                    <>
                                                        <select id="approvedby" defaultValue={eductor["approvedbyid"]} className="form-control"
                                                            style={{ fontSize: "14px", color: "#555555", padding: "7px 12px", border: "1px solid #e7e7e7", borderRadius: "4px", boxShadow: "inset 0px 2px 0px rgba(0, 0, 0, 0.075)" }}>
                                                            <option value="">Select User</option>
                                                            {
                                                                users.map((u, index) => (
                                                                    <option key={index} value={u["id"]}>{`${u["firstname"]} ${u["lastname"]} - ${u["email"]}`}</option>
                                                                ))
                                                            }

                                                        </select>

                                                    </>
                                                }

                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="datecompleted">Date Completed</label>
                                                <input defaultValue={eductor["datecompleted"]} className="form-control" id="datecompleted" name="datecompleted" type="date" readOnly={false} autoComplete="off" />
                                            </div>



                                        </div>

                                        <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "100%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="notes">Notes</label>
                                                <textarea defaultValue={eductor["notes"]} rows="5" className="form-control" id="notes" name="notes" type="text" readOnly={false} autoComplete="off" style={{ color: "var(--bs-secondary)", minWidth: "100%" }} />
                                            </div>

                                        </div>

                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                            <div className="card border-light mb-3" style={{ display: "flex", flexDirection: "column", width: "48%", margin: "1%" }}>
                                                <h4 className="card-header" style={{ marginTop: "-4px", fontWeight: "bold", padding: "8px", color: "var(--bs-blue)" }}>Calculated System Performance</h4>

                                                <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "96%", minWidth: "128px" }}>
                                                    <label style={{ color: "var(--bs-secondary)" }} htmlFor="cspr_inducedairflow">A) Induced Airflow</label>
                                                    <input defaultValue={eductor["cspr_inducedairflow"]} className="form-control" id="cspr_inducedairflow" name="cspr_inducedairflow" type="number" readOnly={false} autoComplete="off" style={{ minWidth: "100%" }} />
                                                </div>

                                                <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "96%", minWidth: "128px" }}>
                                                    <label style={{ color: "var(--bs-secondary)" }} htmlFor="cspr_inletstaticpressure">B) Inlet Static Pressure</label>
                                                    <input defaultValue={eductor["cspr_inletstaticpressure"]} className="form-control" id="cspr_inletstaticpressure" name="cspr_inletstaticpressure" type="number" readOnly={false} autoComplete="off" style={{ minWidth: "100%" }} />
                                                </div>

                                                <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "96%", minWidth: "128px" }}>
                                                    <label style={{ color: "var(--bs-secondary)" }} htmlFor="cspr_dischargestaticpressure">C) Discharge Static Pressure</label>
                                                    <input defaultValue={eductor["cspr_dischargestaticpressure"]} className="form-control" id="cspr_dischargestaticpressure" name="cspr_dischargestaticpressure" type="number" readOnly={false} autoComplete="off" style={{ minWidth: "100%" }} />
                                                </div>

                                            </div>

                                            <div className="card border-light mb-3" style={{ display: "flex", flexDirection: "column", width: "48%", margin: "1%" }}>
                                                <h4 className="card-header" style={{ marginTop: "-4px", fontWeight: "bold", padding: "8px", color: "var(--bs-blue)" }}>Blower Selection Performance Requirements</h4>

                                                <div style={{ display: "flex", flexDirection: "row" }}>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="bspr_airflowacfm">Airflow (ACFM)</label>
                                                        <input defaultValue={eductor["bspr_airflowcfm"]} className="form-control" id="bspr_airflowacfm" name="bspr_airflowacfm" type="number" readOnly={false} autoComplete="off" />
                                                    </div>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="bspr_calculatedbhp">Calculated BHP</label>
                                                        <input defaultValue={eductor["bspr_calculatedbhp"]} className="form-control" id="bspr_calculatedbhp" name="bspr_calculatedbhp" type="number" readOnly={false} autoComplete="off" />
                                                    </div>

                                                </div>

                                                <div style={{ display: "flex", flexDirection: "row" }}>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="bspr_inletstaticpressure">Inlet Static Pressure</label>
                                                        <input defaultValue={eductor["bspr_inletstaticpressure"]} className="form-control" id="bspr_inletstaticpressure" name="bspr_inletstaticpressure" type="number" readOnly={false} autoComplete="off" />
                                                    </div>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="bspr_outletstaticpressure">Outlet Static Pressure</label>
                                                        <input defaultValue={eductor["bspr_outletstaticpressure"]} className="form-control" id="bspr_outletstaticpressure" name="bspr_outletstaticpressure" type="number" readOnly={false} autoComplete="off" />
                                                    </div>

                                                </div>

                                                <div style={{ display: "flex", flexDirection: "row" }}>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="bspr_datecompleted">Date Completed</label>
                                                        <input defaultValue={eductor["bspr_datecompleted"]} className="form-control" id="bspr_datecompleted" name="bspr_datecompleted" type="date" readOnly={false} autoComplete="off" />
                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                            <div className="card border-light mb-3" style={{ display: "flex", flexDirection: "column", width: "48%", margin: "1%" }}>
                                                <h4 className="card-header" style={{ marginTop: "-4px", fontWeight: "bold", padding: "8px", color: "var(--bs-blue)" }}>Actual Performance Results</h4>

                                                <div style={{ display: "flex", flexDirection: "row" }}>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_plenumpressure">Actual Plenum Pressure</label>
                                                        <input defaultValue={eductor["apr_plenumpressure"]} className="form-control" id="apr_plenumpressure" name="apr_plenumpressure" type="number" readOnly={false} autoComplete="off" />
                                                    </div>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_plenumtype">Plenum Type</label>
                                                        <select id="apr_plenumtype" defaultValue={eductor["apr_plenumtype"]} className="form-control"
                                                            style={{ fontSize: "14px", color: "#555555", padding: "7px 12px", border: "1px solid #e7e7e7", borderRadius: "4px", boxShadow: "inset 0px 2px 0px rgba(0, 0, 0, 0.075)" }}>
                                                            <option value="">Select Plenum Type</option>
                                                            <option value="Winged">Winged</option>
                                                            <option value="Straight">Straight</option>

                                                        </select>
                                                    </div>

                                                </div>

                                                <div style={{ display: "flex", flexDirection: "row" }}>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_staticclosedoff">Static Closed Off</label>
                                                        <input defaultValue={eductor["apr_staticclosedoff"]} className="form-control" id="apr_staticclosedoff" name="apr_staticclosedoff" type="number" readOnly={false} autoComplete="off" />
                                                    </div>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_tightorloose">Nozzle Tightness</label>
                                                        <select id="apr_tightorloose" defaultValue={eductor["apr_tight"]} className="form-control"
                                                            style={{ fontSize: "14px", color: "#555555", padding: "7px 12px", border: "1px solid #e7e7e7", borderRadius: "4px", boxShadow: "inset 0px 2px 0px rgba(0, 0, 0, 0.075)" }}>
                                                            <option value="">Select Tightness</option>
                                                            <option value="Tight">Tight</option>
                                                            <option value="Loose">Loose</option>

                                                        </select>
                                                    </div>

                                                </div>

                                                <div style={{ display: "flex", flexDirection: "row" }}>



                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_calculatedblowerairflow">Calculated Air Flow (ACFM)</label>
                                                        <input defaultValue={eductor["apr_calculatedblowerairflow"]} className="form-control" id="apr_calculatedblowerairflow" name="apr_calculatedblowerairflow" type="number" readOnly={false} autoComplete="off" />

                                                    </div>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_nozzlesetting">Nozzle Setting</label>
                                                        <select id="apr_nozzlesetting" defaultValue={eductor["apr_nozzlesetting"]} className="form-select"
                                                            style={{ fontSize: "14px", color: "#555555", padding: "7px 12px", border: "1px solid #e7e7e7", borderRadius: "4px", boxShadow: "inset 0px 2px 0px rgba(0, 0, 0, 0.075)" }}>

                                                            <option value="">Select Nozzle</option>
                                                            <option value="None">None</option>
                                                            <option value="Loose">Loose</option>
                                                            <option value="11/32">11/32"</option>
                                                            <option value="7/16">7/16"</option>
                                                            <option value="1/2">1/2"</option>
                                                            <option value="9/16">9/16"</option>
                                                            <option value="5/8">5/8"</option>
                                                            <option value="11/16">11/16"</option>
                                                            <option value="3/4">3/4"</option>
                                                            <option value="13/16">13/16"</option>
                                                            <option value="7/8">7/8"</option>
                                                            <option value="15/16">15/16"</option>
                                                            <option value="1">1"</option>

                                                        </select>

                                                    </div>

                                                </div>

                                                <div style={{ display: "flex", flexDirection: "row" }}>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_motorrpm">Motor RPM</label>
                                                        <input defaultValue={eductor["apr_motorrpm"]} className="form-control" id="apr_motorrpm" name="apr_motorrpm" type="number" readOnly={false} autoComplete="off" />
                                                    </div>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>

                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="intakesilencer">Intake Silencer</label>
                                                        <select id="intakesilencer" defaultValue={eductor["intakesilencer"]} className="form-control"
                                                            style={{ fontSize: "14px", color: "#555555", padding: "7px 12px", border: "1px solid #e7e7e7", borderRadius: "4px", boxShadow: "inset 0px 2px 0px rgba(0, 0, 0, 0.075)" }}>
                                                            <option value="">Select Option</option>
                                                            <option value="1">Yes</option>
                                                            <option value="0">No</option>

                                                        </select>

                                                    </div>



                                                </div>

                                                <div style={{ display: "flex", flexDirection: "row" }}>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_motorvoltage">Motor Voltage (v)</label>
                                                        <input defaultValue={eductor["apr_motorvoltage"]} className="form-control" id="apr_motorvoltage" name="apr_motorvoltage" type="number" readOnly={false} autoComplete="off" />
                                                    </div>

                                                </div>

                                            </div>

                                            <div className="card border-light mb-3" style={{ display: "flex", flexDirection: "column", width: "48%", margin: "1%" }}>
                                                <h4 className="card-header" style={{ marginTop: "-4px", fontWeight: "bold", padding: "8px", color: "var(--bs-blue)" }}>Motor Amps</h4>

                                                <div style={{ display: "flex", flexDirection: "row" }}>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>

                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_motoramps1">1) Amps</label>
                                                        <input onChange={() => { handleAmpChange() }} defaultValue={eductor["apr_motoramps1"]} className="form-control" id="apr_motoramps1" name="apr_motoramps1" type="number" readOnly={false} autoComplete="off" />
                                                    </div>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_ratedamps">Rated Amps</label>
                                                        <input onClick={() => { toast("This field is modified above", { icon: "💡" }) }} defaultValue={eductor["apr_motorampsrated"]} className="form-control" id="apr_ratedamps" name="apr_ratedamps" type="number" readOnly={true} autoComplete="off" />
                                                    </div>

                                                </div>

                                                <div style={{ display: "flex", flexDirection: "row" }}>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_motoramps2">2) Amps</label>
                                                        <input onChange={() => { handleAmpChange() }} defaultValue={eductor["apr_motoramps2"]} className="form-control" id="apr_motoramps2" name="apr_motoramps2" type="number" readOnly={false} autoComplete="off" />
                                                    </div>

                                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_averageamps">Average Amps</label>
                                                        <input defaultValue={eductor["apr_motorampsaverage"]} onClick={() => { toast("This field is calculated", { icon: "💡" }) }} className="form-control" id="apr_averageamps" name="apr_averageamps" type="number" readOnly={true} autoComplete="off" />
                                                    </div>

                                                </div>

                                                <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                    <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_motoramps3">3) Amps</label>
                                                    <input onChange={() => { handleAmpChange() }} defaultValue={eductor["apr_motoramps3"]} className="form-control" id="apr_motoramps3" name="apr_motoramps3" type="number" readOnly={false} autoComplete="off" />
                                                </div>

                                                <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "100%", minWidth: "128px" }}>
                                                    <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_motornotes">Motor Notes</label>
                                                    <textarea defaultValue={eductor["apr_motornotes"]} rows="5" className="form-control" id="apr_motornotes" name="apr_motornotes" type="text" readOnly={false} autoComplete="off" style={{ color: "var(--bs-secondary)", minWidth: "100%" }} />
                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                                <div className="card border-secondary mb-3" style={{ fontSize: "15px", margin: "auto" }}>

                                    <div className="card-body" style={{ overflowX: "auto" }}>

                                        {tests !== undefined && tests.length > 0 ?
                                            (

                                                <>

                                                    <h4 className="card-title" style={{ fontWeight: "bold", color: "var(--bs-blue)", marginTop: "16px" }}>Eductor Tests</h4>
                                                    {hasUnsavedChanges && <span style={{ color: "var(--bs-danger)", fontWeight: "bold" }}>⚠️ Air Properties have been modified above. Please save changes and reload the page to re-calculate velocity and CFM</span>}

                                                    <table className="table table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">% Open</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">I/O</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">Diameter</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">Gauge</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">Inner Diameter</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">Area</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">SP</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">Velocity</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">CFM</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">Avg√VP</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">VP 1</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">VP 2</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">VP 3</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">VP 4</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">VP 5</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">VP 6</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">VP 7</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">VP 8</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">VP 9</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">VP 10</th>
                                                                <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "14px" }} scope="col">VP 11</th>

                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {tests !== undefined && (
                                                                tests.map((t, index) => (
                                                                    <tr key={index} className={Math.floor(index / 2) % 2 === 0 ? "table-default" : "table-secondary"}>
                                                                        <td style={{ textAlign: "center", color: "var(--bs-dark)", fontWeight: "bold" }}>{t["percentage"]}</td>
                                                                        <td style={{ textAlign: "center", color: "var(--bs-dark)", fontWeight: "bold" }}>{t["inletoutlet"] === "False" ? "Inlet" : "Outlet"}</td>
                                                                        <td style={{ textAlign: "center", color: "var(--bs-dark)", fontWeight: "bold" }}>{t["diameter"]}</td>
                                                                        <td style={{ textAlign: "center", color: "var(--bs-dark)", fontWeight: "bold" }}>{t["gauge"]}{t["gauge"] ? '"' : ''}</td>
                                                                        <td style={{ textAlign: "center", color: "var(--bs-dark)", fontWeight: "bold" }}>{parseFloat(t["innerDiameter"]).toFixed(2)}</td>
                                                                        <td style={{ textAlign: "center", color: "var(--bs-dark)", fontWeight: "bold" }}>{parseFloat(t["area"]).toFixed(3)}</td>
                                                                        <td style={{ textAlign: "center", color: "var(--bs-dark)", fontWeight: "bold" }}>{parseFloat(t["staticpressure"]).toFixed(3)}</td>
                                                                        <td style={{ textAlign: "center", color: "var(--bs-dark)", fontWeight: "bold" }}>{Number(parseFloat(t["velocity"])).toLocaleString(undefined, { maximumFractionDigits: 0 })}</td>
                                                                        <td style={{ textAlign: "center", color: "var(--bs-dark)", fontWeight: "bold" }}>{Number(parseFloat(t["cfm"])).toLocaleString(undefined, { maximumFractionDigits: 0 })}</td>
                                                                        <td style={{ textAlign: "center", color: "var(--bs-dark)", fontWeight: "bold" }}>{parseFloat(t["average"]).toFixed(3)}</td>
                                                                        {[...Array(11)].map((_, i) => (
                                                                            <td key={i} style={{ textAlign: "center" }}>
                                                                                {parseFloat(t[`vp${i + 1}`]).toFixed(1)}
                                                                            </td>
                                                                        ))}
                                                                    </tr>
                                                                ))
                                                            )}
                                                        </tbody>


                                                    </table>

                                                    <div style={{ display: "flex", flexDirection: "row", margin: "8px", justifyContent: "space-between" }}>

                                                        <div style={{ display: "flex", flexDirection: "row", margin: "8px", justifyContent: "flex-start" }}>
                                                            <Link className="btn btn-default" style={{ paddingRight: "8px" }} target="_blank" to="https://dc.cssi.co/Admin/EDUCTOR TEST SETUP.pdf">Test Setup Diagram</Link>
                                                        </div>

                                                        <div style={{ display: "flex", flexDirection: "row", margin: "8px", justifyContent: "flex-end" }}>

                                                            <button onClick={() => { navigate(`/Eductor/Tests/${id}`) }} className="btn btn-primary" style={{ marginRight: "4px", width: "auto" }}>Edit Tests</button>

                                                        </div>

                                                    </div>
                                                </>

                                            )
                                            :
                                            (
                                                <>
                                                    <h4 className="card-title" style={{ fontWeight: "bold", color: "var(--bs-blue)", marginTop: "16px" }}>Eductor Tests</h4>
                                                    <button onClick={() => { handleCreateTemplate() }} className="btn btn-primary" style={{ marginTop: "16px", width: "auto" }}>Create New Test Form</button>
                                                </>
                                            )
                                        }

                                    </div>

                                </div>

                                {tests !== undefined && tests.length > 0 &&
                                    <>
                                        <div className="card border-secondary mb-3" style={{ fontSize: "18px", fontWeight: "bold" }}>

                                            <h4 className="card-title" style={{ fontWeight: "bold", color: "var(--bs-blue)", marginTop: "16px", marginLeft: "8px" }}>Performance Graph</h4>

                                            <PerformanceGraph input={tests} />

                                        </div>
                                    </>
                                }

                                <div style={{ display: "flex", flexDirection: "row", margin: "8px 0px", justifyContent: "space-between" }}>

                                    <Link to="/Eductor" className="btn btn-default" style={{ marginRight: "4px", width: "auto" }}>Return to Eductor List</Link>

                                    {isDeleting
                                        ? (
                                            <>
                                                {/* Are you sure you want to delete this Eductor? */}
                                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "8px" }}>
                                                    <span style={{ color: "var(--bs-danger)", fontWeight: "bold" }}>Are you sure you want to archive this Eductor?</span>
                                                    <button className="btn btn-danger" onClick={() => handleDeleteEductor()}>Confirm Archive</button>
                                                    <button className="btn btn-secondary" onClick={() => setIsDeleting(false)} style={{ marginRight: "4px", width: "auto" }}>Cancel</button>
                                                </div>
                                            </>
                                        )
                                        : (
                                            <>
                                                <button className="btn btn-danger" onClick={() => setIsDeleting(true)}>Archive This Eductor</button>
                                            </>
                                        )

                                    }

                                </div>

                            </div>

                        </>
                    }

                </>

            }

        </div>
    );
}

export default EductorDetails;